import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../redux/slice/system";
import { setUser } from "../../redux/slice/user";
import { CommonAPI } from "../../axios/api";
import { useHookForm } from "../../components/hooks";
import moment from "moment";

import { option_authority_action } from "../../service/option/common";

import LoginCss from "../../styles/components/login.module.scss";

import ImgLogo from "../../images/logo.png";

import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackLogin(props) {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  // 表單欄位預設值
  const defaultValues = {
    username: "",
    password: "",
  };
  const {
    Controller,
    handleSubmit,
    control,
    setValue,
    trigger,
    yup,
    setSchema,
  } = useHookForm({
    defaultValues,
  });
  // 客戶資料
  const [customerData, setCustomerData] = useState({});

  useEffect(() => {
    setSchema(
      yup
        .object({
          username: yup.string().required(),
          password: yup.string().required(),
        })
        .required(),
    );
  }, []);

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress({ show: true }));

    let jsonData = {
      account: submitData.username,
      password: submitData.password,
    };

    CommonAPI.login({
      data: jsonData,
    }).then((result) => {
      let { Response, message } = result;

      switch (Response) {
        case 1:
          result.now = moment().format("YYYY/MM/DD HH:mm:ss");
          dispatch(setUser(result));
          route_navigate("/back/home");
          dispatch(setProgress({ show: false }));
          break;
        case 311:
          dispatch(
            setToast({
              severity: "error",
              summary: "登入失敗",
              detail: message,
            }),
          );
          dispatch(setProgress({ show: false }));
          break;
        default:
          dispatch(
            setToast({
              severity: "error",
              summary: "登入失敗",
              detail: "帳密錯誤",
            }),
          );
          dispatch(setProgress({ show: false }));
          break;
      }
    });
  };

  return (
    <>
      <div
        className={`${LoginCss["login-wrap"]} flex flex-column w-full h-full p-2`}
      >
        <div className="flex flex-column align-items-center justify-content-center h-full">
          <div
            className={`${LoginCss["login-inner-wrap"]} w-11 lg:w-9 xl:w-8 text-2xl px-3`}
          >
            <div className="flex align-items-center lg:flex-row flex-column">
              <div className="w-8 md:w-5 text-center md:mr-6 mr-0">
                <img
                  src={ImgLogo}
                  alt="logo"
                  className="w-12 max-w-20rem lg:mb-0 mb-6"
                />
              </div>

              <div className="w-12 md:w-6 xl:w-5">
                {process.env.REACT_APP_MODE === "development" && (
                  <div className="text-center mb-4 -mt-4">
                    <div className="inline-block text-xl text-white bg-red-500 font-bold px-2 py-1">
                      測試站
                    </div>
                  </div>
                )}

                <h2 className="text-main-dark text-center mt-0 mb-3">
                  公益圖表
                </h2>

                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="p-fluid w-12 sm:w-10 mx-auto"
                >
                  <div className="field flex align-items-center">
                    <Controller
                      name="username"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          {...field}
                          placeholder="輸入帳號"
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                  </div>
                  <div className="field flex align-items-center">
                    <Controller
                      name="password"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Password
                          id={field.name}
                          {...field}
                          placeholder="輸入密碼"
                          toggleMask
                          feedback={false}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                  </div>

                  <Button
                    type="submit"
                    label="登入"
                    className="p-button-main"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
